import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import axiosAuth from "../../axiosAuth";
import { PROPERTY_BLOCK } from "./apiRoutes";

interface mutateProps {
  id: string;
  communityId: string;
}

const mutateDeletePropertyBlock = async ({ id, communityId }: mutateProps) => {
  return await axiosAuth.delete(`${PROPERTY_BLOCK(communityId)}/${id}`);
};

const useDeletePropertyBlockMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    mutateProps,
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateDeletePropertyBlock,
    ...queryParams,
  });

export default useDeletePropertyBlockMutation;
